import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Role } from 'src/app/backend-client/models/Backend/Core/Infrastructure/Aggregates/Identity/role';
import { MxMenuRightsPipe } from 'src/app/shared/pipes';
import { MxIdentityService } from './mx.identity.service';

@Injectable({
  providedIn: 'root',
})
export class MxMenuService {
  private menuSource = new Subject<string>();
  private resetSource = new Subject<void>();

  menuSource$ = this.menuSource.asObservable();
  resetSource$ = this.resetSource.asObservable();

  menu: any[];

  constructor(
    private menuRightsPipe: MxMenuRightsPipe,
    private identityService: MxIdentityService
  ) {
    this.resetMenu();
  }

  resetMenu() {
    this.menu = [
      {
        label: 'Home',
        icon: 'fa fa-home fa-fw',
        routerLink: ['/'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PartnerProgramPharmacy,
          Role.Admin,
          Role.Administrator,
        ]),
      },
      {
        label: 'Claims',
        icon: 'fa fa-exclamation-circle fa-fw',
        routerLink: ['/claims'],
        visible: this.menuRightsPipe.transform([
          Role.Administrator,
          Role.Admin,
          Role.PharmacyBasic,
        ]),
      },
      {
        // a patikák hibajelzései: állapot, megjegyzés
        label: 'Issue_reports_admin',
        icon: 'fa fa-bug fa-fw',
        routerLink: ['/issue-reports'],
        visible: this.menuRightsPipe.transform([Role.Administrator, Role.Admin]),
      },
      {
        label: 'My_invoices',
        icon: 'fa fa-file-invoice fa-fw',
        routerLink: ['/invoice'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PartnerProgramPharmacy,
          Role.PharmacyBasic,
        ]),
      },
      {
        label: 'Invoice_reports',
        icon: 'fa fa-chart-bar fa-fw',
        routerLink: ['/invoice-report'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PartnerProgramPharmacy,
        ]),
      },
      // {
      //   label: 'Sales_reports',
      //   icon: 'fa fa-chart-line fa-fw',
      //   routerLink: ['/sales-report'],
      //   visible: this.menuRightsPipe.transform([
      //     Role.Pharmacy,
      //     Role.PartnerProgramPharmacy,
      //   ]),
      // },
      {
        label: 'NP_dashboard',
        icon: 'fa fa-chart-pie fa-fw',
        routerLink: ['/np-dashboard'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PartnerProgramPharmacy,
        ]),
      },
      {
        label: 'Claims',
        icon: 'fa fa-exclamation-circle fa-fw',
        routerLink: ['/claims'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PartnerProgramPharmacy,
          Role.LogisticsUser,
        ]),
      },
      {
        label: 'Remaining_orders',
        icon: 'fas fa-hand-point-up fa-fw',
        routerLink: ['/remaining-orders'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PartnerProgramPharmacy,
          Role.PharmacyBasic,
        ]),
      },
      {
        label: 'Offers',
        icon: 'fa fa-percent fa-fw',
        routerLink: ['/offers'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PartnerProgramPharmacy,
        ]),
      },
      {
        label: 'Partner_program_assets',
        icon: 'fab fa-markdown fa-fw',
        routerLink: ['/partner-program-assets'],
        visible: this.menuRightsPipe.transform([Role.Administrator, Role.Admin]),
      },
      {
        label: 'Offers_documents',
        icon: 'fa fa-file fa-fw',
        routerLink: ['/offers/documents'],
        visible: this.menuRightsPipe.transform([Role.Administrator, Role.Admin]),
      },
      {
        label: 'Posts',
        icon: 'fas fa-rss fa-fw',
        routerLink: ['/posts/all'],
        visible: !this.menuRightsPipe.transform([Role.AnthroposophyUser, Role.Pharmacist]),
      },
      {
        label: 'AvailableSubstitution',
        icon: 'fas fa-exchange-alt fa-fw',
        routerLink: ['/work-schedule/available'],
        visible: this.menuRightsPipe.transform([Role.Admin, Role.Pharmacist]),
      },
      {
        label: 'MySubstitution',
        icon: 'fas fa-exchange-alt fa-fw',
        routerLink: ['/work-schedule'],
        visible: this.menuRightsPipe.transform([Role.Admin, Role.Pharmacist]),
      },
      {
        label: 'Anthroposophy_products',
        icon: 'fas fa-box fa-fw',
        routerLink: ['/anthroposophy-products'],
        visible:
          this.menuRightsPipe.transform([Role.Admin, Role.AnthroposophyUser]) ||
          this.identityService.accountValue?.subscription
            .isAnthroposophicProductAvailable,
      },
      {
        label: 'Anthroposophy_subscriptions',
        icon: 'fas fa-users fa-fw',
        routerLink: ['/anthroposophy-subscriptions'],
        visible: this.menuRightsPipe.transform([
          Role.Admin,
          Role.AnthroposophyUser,
        ]),
      },
      {
        label: 'Commitment_documents',
        icon: 'fas fa-list fa-fw',
        routerLink: ['/commitment-documents'],
        visible: this.menuRightsPipe.transform([
          Role.PartnerProgramPharmacy,
          Role.Pharmacy,
          Role.Administrator,
          Role.Admin,
          Role.LogisticsUser,
        ]),
      },
      {
        label: 'Product_certificate_documents',
        icon: 'fas fa-file-alt fa-fw',
        routerLink: ['/product-certificate-documents'],
        visible: this.menuRightsPipe.transform([
          Role.PartnerProgramPharmacy,
          Role.Pharmacy,
          Role.Administrator,
          Role.Admin,
          Role.LogisticsUser,
        ]),
      },
      {
        label: 'Partner_program',
        icon: 'fa fa-clinic-medical',
        visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy]),
        items: [
          {
            label: 'Substitutions',
            icon: 'fas fa-exchange-alt fa-fw',
            routerLink: ['/work-schedule/pharmacist'],
            visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy]),
          },
          {
            label: 'Partner_contacts',
            icon: 'fa fa-address-book fa-fw',
            routerLink: ['/partner-contacts'],
            visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy]),
          },
          {
            label: 'Partner_program_report',
            icon: 'fa fa-chart-pie fa-fw',
            routerLink: ['/partner-program-report'],
            visible: this.menuRightsPipe.transform([
              Role.PartnerProgramPharmacy,
            ]),
          },
          {
            label: 'Partner_program_assets',
            icon: 'fab fa-markdown fa-fw',
            routerLink: ['/partner-program-assets'],
            visible: this.menuRightsPipe.transform([
              Role.PartnerProgramPharmacy,
            ]),
          },
          {
            label: 'Sales_reports',
            icon: 'fa fa-chart-line fa-fw',
            routerLink: ['/sales-report'],
            visible: this.menuRightsPipe.transform([
              Role.PartnerProgramPharmacy,
            ]),
          },
        ],
      },
      {
        // Szirom Pont – patikai nézet (a patika saját dolgozói; csak olvasható, a jóváhagyás a Pharmaroadnál marad)
        label: 'Loyalty_pharmacy',
        icon: 'fa fa-star fa-fw',
        visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy, Role.Pharmacy, Role.PharmacyBasic]),
        items: [
          {
            label: 'Loyalty_pharmacy_overview',
            icon: 'fa fa-th-large fa-fw',
            routerLink: ['/szirom-pont/overview'],
            visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy, Role.Pharmacy, Role.PharmacyBasic]),
          },
          {
            label: 'Loyalty_pharmacy_staff',
            icon: 'fa fa-users fa-fw',
            routerLink: ['/szirom-pont/staff'],
            visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy, Role.Pharmacy, Role.PharmacyBasic]),
          },
          {
            label: 'Loyalty_pharmacy_campaigns',
            icon: 'fa fa-bullhorn fa-fw',
            routerLink: ['/szirom-pont/campaigns'],
            visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy, Role.Pharmacy, Role.PharmacyBasic]),
          },
          {
            label: 'Loyalty_pharmacy_trainings',
            icon: 'fa fa-graduation-cap fa-fw',
            routerLink: ['/szirom-pont/trainings'],
            visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy, Role.Pharmacy, Role.PharmacyBasic]),
          },
          {
            label: 'Loyalty_pharmacy_points',
            icon: 'fa fa-list fa-fw',
            routerLink: ['/szirom-pont/points'],
            visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy, Role.Pharmacy, Role.PharmacyBasic]),
          },
          {
            label: 'Loyalty_pharmacy_redemption',
            icon: 'fa fa-gift fa-fw',
            routerLink: ['/szirom-pont/redemption'],
            visible: this.menuRightsPipe.transform([Role.PartnerProgramPharmacy, Role.Pharmacy, Role.PharmacyBasic]),
          },
        ],
      },
      {
        label: 'Szirom_Pont',
        icon: 'fa fa-star fa-fw',
        visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
        items: [
          {
            label: 'Loyalty_members',
            icon: 'fa fa-user-check fa-fw',
            routerLink: ['/loyalty/members'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_pharmacies',
            icon: 'fa fa-clinic-medical fa-fw',
            routerLink: ['/loyalty/pharmacies'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_campaigns',
            icon: 'fa fa-bullhorn fa-fw',
            routerLink: ['/loyalty/campaigns'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_trainings',
            icon: 'fa fa-graduation-cap fa-fw',
            routerLink: ['/loyalty/trainings'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_import',
            icon: 'fa fa-file-excel fa-fw',
            routerLink: ['/loyalty/import'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_reports',
            icon: 'fa fa-flag fa-fw',
            routerLink: ['/loyalty/reports'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_vouchers',
            icon: 'fa fa-gift fa-fw',
            routerLink: ['/loyalty/vouchers'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_messages',
            icon: 'fa fa-bell fa-fw',
            routerLink: ['/loyalty/messages'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_balances',
            icon: 'fa fa-coins fa-fw',
            routerLink: ['/loyalty/balances'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_substitutes',
            icon: 'fa fa-user-nurse fa-fw',
            routerLink: ['/loyalty/substitutes'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
          {
            label: 'Loyalty_settings',
            icon: 'fa fa-sliders-h fa-fw',
            routerLink: ['/loyalty/settings'],
            visible: this.menuRightsPipe.transform([Role.Admin, Role.Administrator]),
          },
        ],
      },
      {
        label: 'Administration',
        icon: 'fa fa-tools fa-fw',
        visible: this.menuRightsPipe.transform([
          Role.Admin,
          Role.Administrator,
        ]),
        items: [
          {
            label: 'Posts',
            icon: 'fas fa-rss fa-fw',
            routerLink: ['/posts'],
            visible: true,
          },
          {
            label: 'Subscriptions',
            icon: 'fa fa-bell fa-fw',
            routerLink: ['/subscriptions'],
            visible: true,
          },
          {
            label: 'Internal_users',
            icon: 'fa fa-user fa-fw',
            routerLink: ['/users/internal'],
            visible: true,
          },
          {
            label: 'Pharmacy_users',
            icon: 'fa fa-user-md fa-fw',
            routerLink: ['/users/pharmacy'],
            visible: true,
          },
          {
            label: 'Pharmacist_users',
            icon: 'fa fa-user-nurse fa-fw',
            routerLink: ['/users/pharmacist'],
            visible: true,
          },
          {
            // rendszerlevelek: mikor, kinek, milyen szöveggel; átirányítás
            label: 'Email_templates',
            icon: 'fa fa-envelope fa-fw',
            routerLink: ['/email-templates'],
            visible: true,
          },
          {
            // kiküldési napló és statisztika
            label: 'Email_log',
            icon: 'fa fa-paper-plane fa-fw',
            routerLink: ['/email-log'],
            visible: true,
          },
        ],
      },
      {
        // a portál és a Szirom Pont app hibáinak bejelentése
        label: 'Issue_reports',
        icon: 'fa fa-bug fa-fw',
        routerLink: ['/issue-reports'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PharmacyBasic,
          Role.PartnerProgramPharmacy,
        ]),
      },
      {
        // a patika alap- és SAP-adatai, módosítási kérés
        label: 'Company_details',
        icon: 'fa fa-building fa-fw',
        routerLink: ['/company-details'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PharmacyBasic,
          Role.PartnerProgramPharmacy,
        ]),
      },
      {
        // Súgó: a patikák és az admin külön kézikönyvet látnak (SzHelpService)
        label: 'Help',
        icon: 'fa fa-question-circle fa-fw',
        routerLink: ['/sugo'],
        visible: this.menuRightsPipe.transform([
          Role.Pharmacy,
          Role.PharmacyBasic,
          Role.PartnerProgramPharmacy,
          Role.Administrator,
          Role.Admin,
        ]),
      },
    ];
  }

  onMenuStateChange(key: string) {
    this.menuSource.next(key);
  }

  reset() {
    this.resetSource.next(undefined);
  }
}
